import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRevert = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "-8 -8 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_16639_1162)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M2.9663 1.12994L2.2373 6.92694L7.9293 5.34094",
				stroke: "#281E38",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.92088 18.2C2.51224 17.6024 2.16355 16.966 1.87988 16.3",
				stroke: "#281E38",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.46104 22.4119C7.9357 22.2326 7.42459 22.014 6.93204 21.7579C6.79871 21.6913 6.66804 21.6199 6.54004 21.5439",
				stroke: "#281E38",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.5385 22.41C14.869 22.6374 14.1791 22.8002 13.4785 22.896",
				stroke: "#281E38",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.0796 18.206C20.6594 18.8216 20.1775 19.3929 19.6416 19.911",
				stroke: "#281E38",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.75879 6.02697C4.11573 3.92676 6.14772 2.35151 8.51986 1.56086C10.892 0.770209 13.4627 0.811332 15.8084 1.67745C18.154 2.54357 20.1346 4.183 21.4237 6.32555C22.7127 8.46809 23.2334 10.9859 22.8998 13.464",
				stroke: "#281E38",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "square"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_16639_1162",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgArrowRevert);
export default ForwardRef;
